import { Box, Inline, Bleed, Divider, Button, ResponsiveRender } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'

type Props = {
  handleBack: () => void
  disabled: boolean
  handleSubmit: () => void
  submitLabel: string
  stepNumber: number
  submitButtonId?: string
  backButtonId?: string
}
const WizardFooter = ({
  stepNumber,
  disabled,
  handleBack,
  submitLabel,
  handleSubmit,
  submitButtonId = '',
  backButtonId = ''
}: Props) => {
  const { t } = useTranslation()

  return (
    <Box position="sticky" bottom={0}>
      <Bleed
        horizontal={{ mobile: 'gutter', tablet: 'large' }}
        bottom={{ mobile: 'gutter', tablet: 'large' }}
      >
        <Divider />
        <Box paddingX="large" paddingY="large" background="white">
          <ResponsiveRender above="mobile">
            <Inline space="xsmall" align="right">
              {stepNumber > 0 && (
                <Button
                  variant="transparent"
                  disabled={disabled}
                  onClick={handleBack}
                  id={backButtonId}
                >
                  {t('common.back', 'Back')}
                </Button>
              )}
              <Button
                type="submit"
                onClick={handleSubmit}
                disabled={disabled}
                id={submitButtonId}
                data={{
                  testid: submitButtonId
                }}
              >
                {submitLabel}
              </Button>
            </Inline>
          </ResponsiveRender>
          <ResponsiveRender below="tablet">
            <Box display="flex" alignItems="center" gap="xsmall">
              {stepNumber > 0 && (
                <Button
                  variant="transparent"
                  disabled={disabled}
                  onClick={handleBack}
                  id={backButtonId}
                >
                  {t('common.back', 'Back')}
                </Button>
              )}
              <Button
                type="submit"
                onClick={handleSubmit}
                disabled={disabled}
                id={submitButtonId}
                data={{
                  testid: submitButtonId
                }}
              >
                {submitLabel}
              </Button>
            </Box>
          </ResponsiveRender>
        </Box>
      </Bleed>
    </Box>
  )
}

export default WizardFooter
